import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import PopularGrid from './components/PopularGrid';
import CTASection from './components/CTASection';
import TestimonialSection from './components/TestimonialSection';
import StatsSection from './components/StatsSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '韩漫大全_好看的韩国漫画_漫画韩漫网址_免费韩漫在线观看-韩漫屋',
            description:
              '韩漫屋汇集了众多好看的韩国漫画，形成韩漫大全，通过专用网址免费在线观看，为您提供流畅的视觉享受和多样娱乐选择。',
            url: 'http://98fire.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '韩漫屋',
              url: 'http://98fire.com/',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'http://98fire.com/',
                },
              ],
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '韩漫屋上的漫画都是免费的吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '是的！韩漫屋所有漫画均可免费在线阅读，无需付费订阅。我们致力于为广大漫迷提供高质量的免费漫画资源，让每个人都能享受阅读的乐趣。',
                },
              },
              {
                '@type': 'Question',
                name: '多久更新一次漫画章节？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '我们与多家韩国漫画平台保持合作，热门连载漫画通常每周更新1-2话，确保您能第一时间追到最新内容。更新时间为每天上午10点和晚上8点。',
                },
              },
              {
                '@type': 'Question',
                name: '可以在手机上阅读吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '当然可以！韩漫屋采用响应式设计，完美适配手机、平板和电脑等各种设备。无论您使用什么设备，都能获得流畅的阅读体验。我们还支持横屏和竖屏双模式阅读。',
                },
              },
              {
                '@type': 'Question',
                name: '如何找到我想看的漫画？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '您可以通过首页的分类导航、搜索功能或排行榜来发现漫画。我们提供按类型、人气、评分等多种筛选方式，帮助您快速找到感兴趣的漫画作品。',
                },
              },
              {
                '@type': 'Question',
                name: '漫画的翻译质量怎么样？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '我们拥有专业的韩语翻译团队，所有漫画都经过严格的翻译和校对流程，确保中文翻译准确流畅，同时保留原作的意境和风格。',
                },
              },
            ],
          }),
        }}
      />
      <div className="min-h-screen bg-stone-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategorySection />
          <PopularGrid />
          <CTASection />
          <TestimonialSection />
          <StatsSection />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}